import Vue from "vue";
import Router from "vue-router";
import RegistrationRoutes from "./routes/register";
// import SearchRoutes from "./routes/search";
import ProfileRoutes from "./routes/profile";
import DashboardRoutes from "./routes/dashboard";
import NewOPDRoutes from "./routes/opd/indexNew";
const PharmacyOnboardRegister = () =>
  import(
    /* webpackChunkName: "PharmacyOnboardRegister" */
    "@/components/onboard/OnboardPharmacy.vue"
  );
const DiagnosticOnboardRegister = () =>
  import(
    /* webpackChunkName: "PharmacyOnboardRegister" */
    "@/components/onboard/OnboardDiagnostic.vue"
  );
const AmbulanceOnboardRegister = () =>
  import(
    /* webpackChunkName: "PharmacyOnboardRegister" */
    "@/components/onboard/OnboardingAmbulance.vue"
  );
const BloodBankOnboardRegister = () =>
  import(
    /* webpackChunkName: "PharmacyOnboardRegister" */
    "@/components/onboard/OnboardBloodBank.vue"
  );
Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },

  routes: [
    /*** DO NOT REMOVE Removed Unused Route for performance enhancement,this can be uncommented later.
             {
                path: "/home-new",
                name: "new-dashboard",
                component: () => import ("@/components/authorization/NewDashboard")
             },
            */
    // {
    //     path: "/SearchMain",
    //     name: "SearchMain",
    //     component: SearchMain
    // },
    /*** DO NOT REMOVE Removed Unused Route for performance enhancement,this can be uncommented later.
               {
                  path: "/poc",
                  name: "poc",
                  component: {
                    render(c) {
                       return c("router-view");
                                }
                             },
                         children: POC
                  },
                */
    // {
    //     path: "/",
    //     name: "Root",
    //     component: () =>
    //         import ("@/components/authorization/HomePage"),
    //     meta: {
    //         requiresAuth: false
    //     }
    // },
    {
      path: "/",
      alias: "/",
      name: "home",
      component: () => import("@/components/general/Home"),
      meta: {
        requiresAuth: false
      }
    },

    /** * DO NOT REMOVE Removed Unused Route for performance enhancement, this can be uncommented later.
              {
                 path: "/frontdesk",
                 name: "frontdesk",
                 component: () => import ("@/components/frontdesk/Frontdesk")
                  },
              */
    {
      path: "/",
      name: "base",
      component: () => import("@/components/Base.vue"),
      children: [
        ...DashboardRoutes,
        // {
        //   path: "/search",
        //   name: "search",
        //   redirect: {
        //     name: "search.doctor"
        //   },
        //   component: {
        //     render(c) {
        //       return c("router-view");
        //     }
        //   },
        //   children: SearchRoutes,
        //   meta: {
        //     requiresAuth: false
        //   }
        // },

        {
          path: "/chat/:id?",
          name: "chat",
          meta: {
            requiresAuth: true
          },
          component: () => import("@/components/chat/Chat")
          // children: [{
          //     path: ':id',
          //     name: 'chat.detail',
          //     component: ChatDetail,
          // }, ],
        },
        {
          path: "/newChat",
          name: "newChat",
          // meta: {
          //   requiresAuth: true
          // },
          component: () => import("@/components/newChat/newChat")
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/components/dashboard/Dashboard"),
          children: DashboardRoutes,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "/profile/:patientId",
          name: "PatientProfile",
          component: () =>
            import(
              "@/components/dashboard/patient/ProfileNew/ProfileLeftSidebar"
            ),
          meta: {
            requiresAuth: true
          }
        },

        // {
        //   path: "/my-center",
        //   name: "MyCenterNew",
        //   component: MyCenterNew
        // },

        {
          path: "/mycenter",
          name: "mycenter",
          component: () => import("@/components/general/mycenter/MyCenterNew"),
          redirect: {
            name: "mycenter.ambulance"
          },
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: "ambulance",
              name: "mycenter.ambulance"
            },
            {
              path: "pharmacy",
              name: "mycenter.pharmacy"
            },
            {
              path: "diagnostics-lab",
              name: "mycenter.diagnostics-lab"
            },
            {
              path: "clinic",
              name: "mycenter.clinic"
            },
            // 404
            {
              path: "bloodbank",
              name: "mycenter.bloodbank"
            }
          ]
        },

        {
          path: "/register",
          name: "register",
          component: () => import("@/components/registration/Register"),
          children: RegistrationRoutes,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/payment-link",
          name: "payment",
          component: () => import("@/components/payment-link/payment-link"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/onboard-patient",
          name: "onboard-patient",
          component: () => import("@/components/onboard/OnboardPatient"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/onboard-doctor",
          name: "onboard-doctor",
          component: () => import("@/components/onboard/OnboardDoctor"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/onboard-allied",
          name: "onboard-allied",
          component: () => import("@/components/onboard/OnboardAllied"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/onboard-pharmacy",
          name: "onboard-pharmacy",
          component: PharmacyOnboardRegister
        },
        {
          path: "/onboard-diagnostics-lab",
          name: "onboard-diagnostics-lab",
          component: DiagnosticOnboardRegister
        },

        {
          path: "/onboard-ambulance",
          name: "onboard-ambulance",
          component: AmbulanceOnboardRegister
        },
        {
          path: "/onboard-bloodbank",
          name: "onboard-bloodbank",
          component: BloodBankOnboardRegister
        },
        /*** DO NOT REMOVE Removed Unused Route for performance enhancement, this can be uncommented later.

                        {
                          path: "/calling",
                          name: "calling",
                          component: {
                            render(c) {
                              return c("router-view");
                                      }
                                        },
                                children: Calling
                          },
                           */

        {
          path: "/profile",
          name: "profile",
          redirect: {
            name: "pageNotFound"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: ProfileRoutes,
          meta: {
            requiresAuth: true
          }
        },

        /** * DO NOT REMOVE Removed Unused Route for performance enhancement,this can be uncommented later.
                         {
                            path: "/events",
                            name: "events",
                            component: () =>import ("@/components/events/EventsTemplate")
                          },
                        */
        // {
        //     path: "/opd/:patientId/:opdId/:type",
        //     name: "opd",
        //     component: () =>
        //         import ("@/components/opd/Dashboard"),
        //     children: OpdRoutes,
        //     meta: {
        //         requiresAuth: true
        //     }
        // },
        {
          path: "/notifications",
          name: "notifications",
          component: () => import("./components/general/Notifications"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: "/pharmacy",
        //   name: "pharmacy",
        //   component: Pharmacy
        // },
        // {
        //   path: "/bloodbank",
        //   name: "bloodbank",
        //   component: Bloodbank
        // },

        {
          path: "/payment",
          name: "payment",
          component: () => import("@/components/Payment/Payment"),
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: ":paymentId",
              name: "payment.summary",
              component: () => import("@/components/Payment/Payment")
            }
          ]
        },

        {
          path: "/orders",
          name: "orders",
          meta: {
            requiresAuth: true
          },
          component: () => import("@/components/Payment/Orders")
        },

        {
          path: "/orders/:orderId",
          name: "orders.summary",
          meta: {
            requiresAuth: true
          },
          component: () => import("@/components/Payment/OrderSummary")
        },

        // {
        //     path: "/ambulance-summary",
        //     name: "ambulance-summary",
        //     component: AmbulanceSummary
        // },
        // {
        //     path: "/hospital-summary",
        //     name: "hospital-summary",
        //     component: HospitalSummary
        // },

        {
          path: "/requestSuccessModal",
          name: "requestSuccess",
          meta: {
            requiresAuth: true
          },
          component: () => import("@/components/general/requestSuccessShow.vue")
        },

        // {
        //   path: "/patient-summary",
        //   name: "patient-summary",
        //   component: PatientSummary
        // },
        // {
        //     path: "/admin-dashboard",
        //     name: "admin-dashboard",
        //     component: AdminDashboard
        // },

        {
          path: "/orders-detail",
          name: "orders-detail",
          meta: {
            requiresAuth: true
          },
          component: () => import("@/components/Payment/OrdersDetail")
        },


        // {
        //   path: "/DashSettings",
        //   name: "DashSettings",
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: () => import("@/components/dashSetting/dashSettingSide")
        // },

        {
          path: "/OPDLeftSidebar/:patientId/:opdId/:type?",
          component: () => import("@/components/OPDNew/OPDLeftSidebar"),
          name: "OPDLeftSidebar",
          meta: {
            requiresAuth: true
          },
          children: NewOPDRoutes
        }
      ],

      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/privacy-policy",
      name: "privacy-policy",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/authorization/PrivacyPolicy")
    },

    {
      path: "/terms-conditions/:scrollId",
      name: "TermsConditions",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/authorization/Terms&Conditions")
    },

    {
      path: "/pay-per-use-terms-conditions",
      name: "PayPerUseTermsConditions",
      meta: {
        requiresAuth: false
      },
      component: () =>
        import("@/components/authorization/payPerUseTermsConditions.vue")
    },
    {
      path: "/FAQ",
      name: "FAQ",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/authorization/FAQ")
    },
    {
      path: "/services",
      name: "services",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/authorization/services")
    },

    {
      path: "/about-us",
      name: "AboutUs",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/authorization/AboutUs")
    },

    {
      path: "/contact-us",
      name: "ContactUs",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/authorization/ContactUs")
    },
    {
      path: "/poc-speech-to-text",
      name: "POCSpeechToText",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/authorization/POCSpeechToText")
    },

    {
      path: "/qr-codes/:qrCodeId",
      name: "qrCode",
      meta: {
        onlyRouterView: true
      },
      component: () => import("@/components/QrCode")
    },

    {
      path: "/s3-viewer",
      name: "UploadView",
      meta: {
        onlyRouterView: true
      },
      component: () => import("@/components/elements/UploadView")
    },

    // 404
    {
      path: "*",
      name: "pageNotFound",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/components/general/error/PageNotFound")
    }
  ]
});

// main auth and login check function
router.beforeEach((to, from, next) => {
  // const current_role = router.app.$store.state.user.currentRole;
  // const completed_profiles = router.app.$store.state.user.info.completed_profiles;
  // const is_logged_in = localStorage.getItem("token") ? true : false;

  // if (is_logged_in == true && (completed_profiles && completed_profiles.includes(current_role) == false)) {

  //   if (to.path != "/onboard-doctor" && current_role == "doctor") {
  //     router.push({
  //       path: "/onboard-doctor"
  //     });
  //   }

  //   if (to.path != "/onboard-patient" && current_role == "patient") {
  //     router.push({
  //       path: "/onboard-patient"
  //     });
  //   }

  // } else {
  //   if (to.path == "/onboard-doctor" || to.path == "/onboard-patient") {
  //     router.push({
  //       path: "/"
  //     });
  //   }
  // }

  if (to.meta.requiresAuth) {
    //    page  is autorized go to check login if not then redirect next
    // if (!is_logged_in) {
      //    if user not login then go login page
      // router.push({
      //   path: "/"
      // });

    // } else {
      //    if user login then go next
      next();
    // }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
